import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  TagRightIcon,
  useToast,
  VStack
} from '@chakra-ui/react'
import { Form } from './Form'
import useClawPrizes from './hooks/useClawPrizes'
import { AdminSeasonClawMachinePrize } from '@olagg/db-types'
import { SeasonClawPrizeFormData } from '@olagg/validation-schemas'

const EditSeasonClawPrize = () => {
  const { id: gameSeasonId, prize_id: prizeId } = useParams<{ id: string, prize_id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { getClawPrize, updateClawPrize, loading } = useClawPrizes()

  const [prize, setPrize] = useState<AdminSeasonClawMachinePrize | null>(null)
  const [loadingPrize, setLoadingPrize] = useState(true)

  useEffect(() => {
    const loadPrize = async () => {
      if (!prizeId || !gameSeasonId) return
      try {
        setLoadingPrize(true)
        const prizeData = await getClawPrize(prizeId, gameSeasonId)
        setPrize(prizeData.gameSeasonClawMachinePrize)
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar el premio',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate('/seasons')
      } finally {
        setLoadingPrize(false)
      }
    }

    loadPrize()
  }, [prizeId, gameSeasonId])

  const onSubmit = async (data: SeasonClawPrizeFormData) => {
    if (!prize || !gameSeasonId) return

    try {
      const updateData = {
        ...data,
        clawMachinePrizeId: Number(data.clawMachinePrizeId),
        game_season_id: gameSeasonId
      } as any;
      
      await updateClawPrize(prize.id.toString(), updateData)
      toast({
        title: 'Premio actualizado',
        description: 'El premio ha sido actualizado exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate(`/seasons/${gameSeasonId}/claw-machine-prizes`)
    } catch (error) {
      console.error('Error updating prize:', error)
      toast({
        title: 'Error',
        description: 'No se pudo actualizar el premio',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate('/seasons')
  }

  if (loadingPrize) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner size="lg" />
      </Flex>
    )
  }

  if (!prize) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          Premio no encontrado
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar premio</Heading>

        <Form
          initialData={prize}
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={true}
        />
      </VStack>
    </Center>
  )
}

export default EditSeasonClawPrize;